import { PrimaryProgressButton } from '@stacc/flow-ui-components'
import { useState } from 'react'
import { withTranslation } from 'react-i18next'
import type { TaskProps } from '../../types/TaskProps'
import {
  GroupPaddedGrow,
  LeftContent,
  RightContent,
  ScreenContainer
} from '../common/TaskViewContainerStyle'
import ContextGroup from '../common/task-context/ContextGroup'

const KycErrorSummary = ({ close, flow, onRetry, t, task }: TaskProps) => {
  const {
    data: { customerDeclaration, customer, productId },
    referenceId
  } = flow

  const [isSubmitting, setIsSubmitting] = useState(false)

  const request = {
    applicationId: referenceId,
    productCode: String(productId),
    sourceSystem: 'FLOW',
    applicant: customerDeclaration
  }

  const simplifiedErrorMessage = task?.errorMessage?.split(' at settle')?.[0]

  const handleOnRetry = () => {
    setIsSubmitting(true)
    onRetry(
      task.taskId,
      () => {
        close()
      },
      () => {
        setIsSubmitting(false)
      }
    )
  }

  return (
    <ScreenContainer>
      <LeftContent>
        <div className="flex flex-col gap-6 p-6">
          {simplifiedErrorMessage && (
            <div className="rounded-lg border border-red-400 bg-red-100 p-4 text-red-800">
              <div className="flex items-center space-x-2 font-semibold">
                <svg
                  className="h-5 w-5 text-red-600"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 9v2m0 4h.01M21 12A9 9 0 1 1 3 12a9 9 0 0 1 18 0z"
                  />
                </svg>
                <span>Error</span>
              </div>
              <div className="mt-2 text-sm">{simplifiedErrorMessage}</div>
            </div>
          )}

          <div>
            <p className="mb-2 font-semibold text-gray-700">Request Payload</p>
            <pre className="text-sm bg-gray-50 p-4 rounded border overflow-x-auto whitespace-pre-wrap break-words">
              {JSON.stringify(removeNullsDeep(request), null, 2)}
            </pre>
          </div>
        </div>
      </LeftContent>
      <RightContent>
        <GroupPaddedGrow>
          <ContextGroup
            title={customer.name}
            context={{
              ssn: customer.id,
              phone: customer.phone,
              email: customer.email
            }}
          />
          <div className="pt-2">
            <PrimaryProgressButton
              type="submit"
              onClick={handleOnRetry}
              disabled={isSubmitting}
              isLoading={isSubmitting}
            >
              {t('btn-retry')}
            </PrimaryProgressButton>
          </div>
        </GroupPaddedGrow>
      </RightContent>
    </ScreenContainer>
  )
}

const removeNullsDeep = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj
      .map(removeNullsDeep)
      .filter((item) => item !== null && item !== undefined)
  }

  if (obj && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj)
        .map(([k, v]) => [k, removeNullsDeep(v)])
        .filter(([_, v]) => v !== null && v !== undefined)
    )
  }
  return obj
}

export default withTranslation('inbox')(KycErrorSummary)
